export default __webpack_public_path__ + "static/media/HR.e323c2a3.png";